import i18n, { type InitOptions } from 'i18next';
import { initReactI18next } from 'react-i18next';

import { isBrowser } from '@@utils/isBrowser';

import { LANG_CODES } from './constants';
import locales from './translations';

// This is necessary as when called from tests or mock server, import.meta.env is not available
const getEnv = () => (isBrowser() ? import.meta.env.MODE : process.env.NODE_ENV);

// the translations
// (tip move them in a JSON file and import them)
const resources: InitOptions['resources'] = {
    [LANG_CODES.ENGLISH]: {
        translations: locales[LANG_CODES.ENGLISH],
    },
    [LANG_CODES.GERMAN]: {
        translations: locales[LANG_CODES.GERMAN],
    },
    [LANG_CODES.FRENCH]: {
        translations: locales[LANG_CODES.FRENCH],
    },
};

const options: InitOptions = {
    debug: false,
    resources: getEnv() !== 'test' ? resources : {},
    lng: LANG_CODES.ENGLISH,

    keySeparator: false,
    nsSeparator: false,
    defaultNS: 'translations',
    interpolation: {
        escapeValue: false, // react already safes from xss
    },
    react: {
        useSuspense: false,
    },
};

i18n.use(initReactI18next) // passes i18n down to react-i18next
    .init(options);

export default i18n;
